module.exports = __webpack_public_path__ + "static/img/en-2.5a11038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag_translation/en-2.png
// module id = zISM
// module chunks = 1